import { Flex, Tag } from 'antd';
import { useCallback } from 'react';

import { DATE_PICKER_FORMAT } from '@app/constants';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const PeriodSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangePeriod } = useNewClientsListContext();
  const { period } = filtersMap.get(id)!;

  const onDelete = useCallback(
    (index: number) => {
      if (period === null) {
        return;
      }
      const [start, end] = period;
      if (index === 0) {
        onChangePeriod([null, end], id);
        return;
      } else {
        onChangePeriod([start, null], id);
        return;
      }
    },
    [period, onChangePeriod, id]
  );

  if (period === null) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {period?.map((date, index) => {
        if (!date) {
          return null;
        }

        const label =
          index === 0
            ? `с ${date.format(DATE_PICKER_FORMAT[0])}`
            : `по ${date.format(DATE_PICKER_FORMAT[0])}`;
        return (
          <Tag
            key={date.format(DATE_PICKER_FORMAT[0])}
            className={`${PF}__tag`}
            closable
            onClose={() => onDelete(index)}
          >
            {label}
          </Tag>
        );
      })}
    </Flex>
  );
};
